export default __webpack_public_path__ + "static/media/sad_magnifying_glass.2d679b6b.png";